var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgServiceIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 82,
    height: 82,
    rx: 9.5,
    fill: "white",
    stroke: "#E2E4E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.043 42C31.043 48.0417 35.9578 52.9565 41.9995 52.9565C48.0412 52.9565 52.956 48.0417 52.956 42C52.956 35.9582 48.0412 31.0435 41.9995 31.0435C35.9578 31.0435 31.043 35.9582 31.043 42ZM32.6094 41.9999C32.6094 36.8214 36.8222 32.6086 42.0007 32.6086C47.1792 32.6086 51.392 36.8214 51.392 41.9999C51.392 47.1785 47.1792 51.3913 42.0007 51.3913C36.8222 51.3913 32.6094 47.1785 32.6094 41.9999Z",
    fill: "#47B638"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9996 45.1305C43.7285 45.1305 45.13 43.729 45.13 42.0001C45.13 40.2712 43.7285 38.8696 41.9996 38.8696C40.2707 38.8696 38.8691 40.2712 38.8691 42.0001C38.8691 43.729 40.2707 45.1305 41.9996 45.1305Z",
    fill: "#47B638"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3346 34.433C57.919 34.753 57.4659 35.027 56.9776 35.2359C57.9253 37.3341 58.4348 39.631 58.4348 42C58.4348 51.0626 51.0626 58.4348 42 58.4348C32.9374 58.4348 25.5652 51.0626 25.5652 42C25.5652 32.9374 32.9374 25.5652 42 25.5652C45.1477 25.5652 48.221 26.4879 50.8505 28.1682C50.7034 28.5798 50.6087 29.0165 50.6087 29.4783C50.6087 31.6359 52.3641 33.3913 54.5217 33.3913C56.6794 33.3913 58.4348 31.6359 58.4348 29.4783C58.4348 27.3206 56.6794 25.5652 54.5217 25.5652C53.3885 25.5652 52.3743 26.0575 51.659 26.8299C48.7868 25.0025 45.4333 24 42 24C32.075 24 24 32.075 24 42C24 51.925 32.075 60 42 60C51.925 60 60 51.925 60 42C60 39.3462 59.4185 36.7722 58.3346 34.433Z",
    fill: "#47B638"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceIcon1);
export default __webpack_public_path__ + "static/media/service-icon1.cf205a977052aab165a611b028ece3ea.svg";
export { ForwardRef as ReactComponent };